import React, {useEffect} from 'react';
import './App.css';
import theme from "./core/theme-provider";
import {StyledEngineProvider, Theme, ThemeProvider,} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {BlockSchemeEditor} from "./components/editor/block-scheme-editor";
import {BarContextProvider} from "./components/context/bar-context";
import {SettingsContextProvider} from "./components/context/settings-context";
import {PlaybackContextProvider} from "./components/context/playback-context";
import YouTube from 'react-youtube';

declare module '@mui/styles/defaultTheme' {
    // eslint-disable-next-line @typescript-eslint/no-empty-interface
    interface DefaultTheme extends Theme {
    }
}


function App() {

    const classes = useStyles();
    // const opts = {
    //     height: '390',
    //     width: '640',
    //     playerVars: {
    //         autoplay: 1
    //     },
    // };
    const [hasAccess, setHasAccess] = React.useState(false);
    const onReady = (event) => {
        // access to player in all event handlers via event.target
        event.target.pauseVideo();
    }
    useEffect(() => {
        if (localStorage.getItem('Slava Ukraini') === 'Geroyam Slava' && localStorage.getItem('Slava Natsii') === 'Smert vorogam') {
            setHasAccess(true)
        }
    }, [])

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <SettingsContextProvider>
                    <BarContextProvider>
                        <PlaybackContextProvider>
                            <div className="App">
                                <div className={classes.contentArea}>
                                    <div className={classes.mainContentArea}>
                                        {hasAccess ? <BlockSchemeEditor/> :
                                            <div style={{width: "100vw", height: "100vh"}}>
                                                <div style={{backgroundColor: "red", height: "50vh"}}>
                                                    <YouTube videoId="nPphpz08ifw" onReady={onReady}/>
                                                </div>
                                                <div style={{backgroundColor: "black", color: "red", height: "50vh"}}>
                                                    <span>Слава Україні! Героям Слава!</span>
                                                    <br/>
                                                    <span>Слава Нації! Смерть ворогам!</span>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </PlaybackContextProvider>
                    </BarContextProvider>
                </SettingsContextProvider>
            </ThemeProvider>
        </StyledEngineProvider>
    );
}

const useStyles = makeStyles({
    contentArea: {
        backgroundColor: '#2c2c2c',
        display: 'flex',
        padding: '10px',
        minHeight: '70vh',
        position: "relative"
    },
    mainContentArea: {
        display: 'flex',
        padding: '0 10px',
        justifyContent: 'space-between',
        overflowY: "hidden"
    }
});

export default App;
